import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAttributionFromUrl } from "@/lib/marketing/attribution";
import { mailKlickErfassen } from "@/lib/marketing/strecke";

// Klick aus einer Strecken-Mail (KS1): schon beim Laden des Moduls, bevor eine Seite weiterleitet und die Angaben
// aus der Adresse verliert.
mailKlickErfassen();

/**
 * Globaler Attribution-Capturer: Liest beim ersten Render und bei jedem
 * URL-Wechsel UTM-/fbclid-/gclid-Parameter und persistiert sie im
 * sessionStorage. Erst-Capture gewinnt.
 */
export const AttributionCapture = () => {
  const location = useLocation();

  useEffect(() => {
    try {
      captureAttributionFromUrl();
    } catch {
      /* tracking darf nie blockieren */
    }
  }, [location.pathname, location.search]);

  return null;
};

export default AttributionCapture;
